import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { Box } from 'rebass/styled-components';
import { observer } from 'mobx-react';

import useStores from 'shared/hooks/use-stores';

import { Tip } from 'src/components/tip/tip';

function TipField() {
  const { Cart } = useStores();
  const { costBreakdown } = Cart;

  const [tipResetKey, setTipResetKey] = useState(0);
  const prevTipValueRef = useRef(Cart.tipValue);
  useEffect(() => {
    const prev = prevTipValueRef.current;
    prevTipValueRef.current = Cart.tipValue;
    if (prev !== null && Cart.tipValue === null) {
      setTipResetKey((k) => k + 1);
    }
  }, [Cart.tipValue]);

  const onChangeTip = (value, dollar = true) => {
    Cart.applyTip(dollar ? `dollar` : `percent`, value / 100);
  };

  const defaultTipData = [
    {
      id: 1,
      amount: 0,
      percentage: 10,
    },
    {
      id: 2,
      amount: 200,
      percentage: 15,
    },
    {
      id: 3,
      amount: 400,
      percentage: 20,
    },
    {
      id: 4,
      amount: 800,
      percentage: 25,
    },
    {
      id: 5,
      amount: `other`,
      percentage: 0,
    },
  ];

  return (
    <Container data-cy='driver-tip-container' data-test='driver-tip-container' data-testid='driver-tip-container'>
      <Tip
        key={tipResetKey}
        tipData={defaultTipData}
        data-testid='tip-field'
        onChangeTipAmount={onChangeTip}
        usePercent
        subTotal={costBreakdown.cartSubtotal}
        readonly={false}
      />
    </Container>
  );
}

export default observer(TipField);

const Container = styled(Box)`
  padding: 23px 0 20px 0;
  border-bottom: 1px solid var(--dcm-checkout-summary-border-color, #d3dadf);
`;
